import { postSse } from '../sse';

import { apiClient } from './axios';

import type {
  StockAssistantEvent,
  StockChatRequest,
  StockInterpretRequest,
  StockInterpretResponse,
  StockTranscribeResponse,
} from '@repo/shared-types';

export const stockAssistantApi = {
  interpret: async (req: StockInterpretRequest, signal?: AbortSignal) =>
    (
      await apiClient.post<StockInterpretResponse>(
        '/crm-integration/stock/assistant/interpret',
        req,
        { timeout: 60000, signal, skipErrorToast: true },
      )
    ).data,

  transcribe: async (audio: Blob) => {
    const form = new FormData();
    const ext = audio.type.includes('mp4') ? 'm4a' : audio.type.includes('ogg') ? 'ogg' : 'webm';
    form.append('audio', audio, `voice-note.${ext}`);
    return (
      await apiClient.post<StockTranscribeResponse>(
        '/crm-integration/stock/assistant/transcribe',
        form,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 60000,
          skipErrorToast: true,
        },
      )
    ).data;
  },

  chat: (req: StockChatRequest, onEvent: (e: StockAssistantEvent) => void, signal?: AbortSignal) =>
    postSse<StockAssistantEvent>('/crm-integration/stock/assistant/chat', req, onEvent, signal),
};
